// Spell/ability icon URL helper. Used for debuffs (and any other ability
// where the backend exposes WCL's `icon` field). Class/spec icons live in
// `data/classes.ts` because they're a fixed set we bundle locally.
//
// WCL ships icon names that match Wowhead's CDN file format exactly, e.g.
// "spell_holy_powerwordshield.jpg". Both with and without the .jpg suffix
// are accepted for safety against future schema tweaks.

const LOCAL_BASE = "/icons";
const WOWHEAD_BASE = "https://wow.zamimg.com/images/wow/icons/large";

/**
 * URLs to try, in order, when rendering a spell icon. SpellIcon walks this
 * list on `<img onError>`. Local-first so the run-once `make sync-icons`
 * script keeps things instant after the first import; falls back to
 * Wowhead's CDN for icons we haven't cached yet.
 */
export function spellIconUrls(icon: string | null | undefined): string[] {
  if (!icon) return [];
  const file = icon.toLowerCase().endsWith(".jpg") ? icon : `${icon}.jpg`;
  return [`${LOCAL_BASE}/${file}`, `${WOWHEAD_BASE}/${file}`];
}
